import {type} from 'arktype';
import {TypeOf, literal, union} from 'io-ts';

export const LegacyAddressStatus = union([literal('success'), literal('pending'), literal('')]);
export type LegacyAddressStatus = TypeOf<typeof LegacyAddressStatus>;

export type AddressStatus = (typeof AddressStatus.variants)[number];
export namespace AddressStatus {
    export function toLegacy(addressStatus: AddressStatus | undefined | null): LegacyAddressStatus {
        switch (addressStatus) {
            case 'success':
                return 'success';
            case 'pending':
                return 'pending';
            default:
                return '';
        }
    }

    export const variants = ['pending', 'reject', 'expired', 'success', 'none'] as const;
    export const schema = type.enumerated(...variants);
}
